import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from "../../../services/apiroutes";

@Injectable({
    providedIn: 'root'
})
export class QuickAddCompanyApiService {
    base_url = ApiRoutes.Company;

    constructor(
        private http: HttpClient,
    ) { }

    addCompany(data) {
        let url = `${this.base_url}register/`;
        return this.http.post(url, data)
    }
}